<form [formGroup]="contractUtFormGroup" class="category-content">
    <div class="data-container light-border">
        <span class="data-title">Commerciaux accédant au contrat</span>
        <div class="tv-rect-input-small-no-label full-width">
            <mat-form-field>
                <input
                        matInput
                        formControlName="ut"
                        [matAutocomplete]="autoUt"
                />
                <mat-autocomplete autoActiveFirstOption class="tv-custom-always-visible-scroll-bar"
                                  #autoUt="matAutocomplete"
                                  [displayWith]="displayAutoCompleteData"
                                  (optionSelected)="addUtToList($event.option.value)">
                    <mat-option
                            *ngFor="let contractUt of filteredContractUtList | async"
                            class="tv-ns-select-option"
                            [value]="contractUt">
                        {{ contractUt.name }} - {{ contractUt.id }}
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field>
        </div>
    </div>
</form>


<!-- Ut List -->
<div class="bloc-container" *ngIf="contractUserList?.length > 0">
    <ng-container>
        <div class="container-chips">
            <div class="block-chip" *ngFor="let item of contractUserList">
                <span *ngIf="item.user.name && item.user.id" class="text">
                    {{ item.user.name }} ({{ item.user.id}})
                </span>
                <mat-icon (click)="removeUt(item)">cancel</mat-icon>
            </div>
        </div>
    </ng-container>
</div>
